// extracted by mini-css-extract-plugin
export default {"inner-tab-container":"AnalyticsDataDashboard_inner-tab-container__3UXpo"};